/*
  Cookie Cult — redesigned PDP + cart drawer module.
  One vanilla module holding state {picker, cart, drawerOpen, scrolled}.
  Cart wired via Shopify AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js).
*/
(function () {
  'use strict';

  /* Two hosts share this module:
     - [data-cc-pdp]   the full product page (sections/cc-pdp.liquid)
     - [data-cc-shell] the global chrome on every other page
       (snippets/cc-global-shell.liquid): marquee + header + nav + bag
       drawer only. All PDP-only elements (gallery, picker tiles, add bar,
       reviews modal…) are simply absent there — every lookup below is
       null-guarded, so those features no-op on shell pages. */
  var root = document.querySelector('[data-cc-pdp]') || document.querySelector('[data-cc-shell]');
  if (!root || root.dataset.ccPdpBound === '1') return;
  root.dataset.ccPdpBound = '1';

  var configEl = document.getElementById('cc-pdp-data');
  if (!configEl) return;
  var config = JSON.parse(configEl.textContent);
  var products = config.products || []; // [{variantId,name,price,list,img,sub}]
  var framing = config.framing || 'first-order';
  var pct = config.pct || 56;

  var state = {
    picker: {}, // variantId -> qty
    cart: null,
    drawerOpen: false,
    scrolled: false,
    slide: 0
  };
  products.forEach(function (p) { state.picker[p.variantId] = 0; });

  /* ---------- visit journey log ----------
     One summary per visit to the Worker's /log (7-day KV, type 'journey'):
     which steps were reached and when, gallery use, scroll depth, dwell.
     Sent when the page is hidden or on the way to checkout, plus a 30s
     snapshot because TikTok's webview doesn't always fire a hide event.
     Sends only when something changed, keeping KV writes to ~1–2 a visit. */
  var journey = (function () {
    var noop = { step: function () {}, count: function () {}, slide: function () {}, send: function () {}, bags: function () {} };
    if (!document.querySelector('[data-cc-pdp]')) return noop;
    var LOG_URL = 'https://tiktok-events-proxy.cookiecult.workers.dev/log';
    var started = Date.now();
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { params = { get: function () { return null; } }; }
    var data = {
      sid: Math.random().toString(36).slice(2, 10),
      src: params.get('utm_source') || (document.referrer ? 'referrer' : 'direct'),
      campaign: (params.get('utm_campaign') || '').slice(0, 60),
      ad: (params.get('utm_content') || '').slice(0, 40),
      webview: /BytedanceWebview|musical_ly|trill_|TikTok/i.test(navigator.userAgent || ''),
      screen_h: window.innerHeight,
      steps: {},
      gallery_swipes: 0,
      gallery_arrows: 0,
      gallery_dots: 0,
      gallery_max: 0,
      max_scroll: 0,
      max_scroll_pct: 0,
      bags_first: null,
      bags_max: 0,
      bags_last: null,
      bags_at_checkout: null,
      bags_at_close: null
    };
    var lastSig = '';
    function step(name) {
      if (!Object.prototype.hasOwnProperty.call(data.steps, name)) data.steps[name] = Math.round((Date.now() - started) / 1000);
    }
    function count(name) { data[name] = (data[name] || 0) + 1; }
    /* bags in the basket: first non-empty count, peak, latest, and the count at checkout / on closing the drawer */
    function bags(n, moment) {
      if (typeof n !== 'number') return;
      if (n > 0 && data.bags_first === null) data.bags_first = n;
      if (n > data.bags_max) data.bags_max = n;
      data.bags_last = n;
      if (moment === 'checkout') data.bags_at_checkout = n;
      if (moment === 'close') data.bags_at_close = n;
    }
    function slide(i) {
      if (i > data.gallery_max) data.gallery_max = i;
      if (i > 0) step('gallery_moved');
    }
    function onScroll() {
      var y = Math.round(window.scrollY || document.documentElement.scrollTop || 0);
      if (y <= data.max_scroll) return;
      data.max_scroll = y;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      data.max_scroll_pct = h > 0 ? Math.min(100, Math.round(y / h * 100)) : 0;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    function send(reason) {
      var sig = JSON.stringify(data.steps) + '|' + data.gallery_max + '|' + data.gallery_swipes + '|' + data.max_scroll +
                '|' + data.bags_last + '|' + data.bags_max + '|' + data.bags_at_close;
      if (sig === lastSig) return;
      lastSig = sig;
      data.reason = reason;
      data.dwell_s = Math.round((Date.now() - started) / 1000);
      var body = JSON.stringify({ type: 'journey', message: 'PDP visit journey', details: data,
                                  page_url: location.pathname, user_agent: navigator.userAgent || '' });
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(LOG_URL, new Blob([body], { type: 'text/plain' }))) return;
      } catch (e) {}
      try {
        fetch(LOG_URL, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true, mode: 'cors' }).catch(function () {});
      } catch (e) {}
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') send('hidden');
    });
    window.addEventListener('pagehide', function () { send('pagehide'); });
    window.setTimeout(function () {
      if (document.visibilityState === 'visible') send('snapshot_30s');
    }, 30000);
    if ('IntersectionObserver' in window) {
      [['.cc-picker', 'flavours_seen'], ['[data-cc-pick-add]', 'buy_button_seen'], ['.cc-bites', 'bites_seen'], ['.cc-spot', 'ingredients_seen'],
       ['.cc-info', 'info_seen'], ['.cc-reviews', 'reviews_seen']].forEach(function (pair) {
        var el = document.querySelector(pair[0]);
        if (!el) return;
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { step(pair[1]); io.disconnect(); }
        }, { threshold: 0.3 });
        io.observe(el);
      });
    }
    return { step: step, count: count, slide: slide, send: send, bags: bags };
  })();

  /* Debug freeze. DevTools rebuilds its Styles pane on every DOM mutation,
     which kills a text selection you were part way through dragging, so the
     page's self-updating bits need a way to hold still while it's open.
     Chrome exposes no dependable signal for "DevTools is open" — the usual
     window-size and console-getter tricks are guesses that misfire — so this
     is an explicit switch instead. Load once with ?cc-freeze=1 to set it and
     ?cc-freeze=0 to clear, or flip localStorage directly from the console;
     it's read per tick, so it takes hold without a reload. Stored per
     browser, so it can never follow a change out to a customer. */
  var FREEZE_KEY = 'cc-freeze';
  try {
    var freezeParam = new URLSearchParams(window.location.search).get(FREEZE_KEY);
    if (freezeParam === '1') window.localStorage.setItem(FREEZE_KEY, '1');
    else if (freezeParam === '0') window.localStorage.removeItem(FREEZE_KEY);
  } catch (e) {}
  function frozen() {
    try { return window.localStorage.getItem(FREEZE_KEY) === '1'; } catch (e) { return false; }
  }

  function gbp(cents) { return '\u00a3' + (cents / 100).toFixed(2); }
  function byVariant(id) {
    return products.find(function (p) { return String(p.variantId) === String(id); });
  }

  /* ---------- header scroll state ---------- */
  var header = root.querySelector('[data-cc-header]');
  var marqueeEl = root.querySelector('.cc-marquee');
  var marqueeAtTop = null;
  /* The ink block at the top is the header. It is sticky on every page
     now, so its rect never leaves the viewport and the status bar stays
     dark; the check is kept so this keeps working if that changes. */
  var isDarkPdp = root.classList.contains('cc-pdp--dark');
  var topBlockEl = header || marqueeEl;
  var topAwayColor = isDarkPdp ? '#1a1f1b' : '#f5f6ff';
  var THRESHOLD = 290;
  function onScroll() {
    var sc = window.scrollY > THRESHOLD;
    if (sc !== state.scrolled) {
      state.scrolled = sc;
      root.classList.toggle('cc-scrolled', sc);
    }
    /* --- iPhone status bar / Dynamic Island colour driver ---
       While the ink marquee is on screen at the top, the status bar area
       above it goes dark (#111412); once it scrolls away, porcelain
       returns. Two mechanisms, because iOS versions disagree:
       1. iOS 26: .cc-tint-strip-top, a fixed strip hidden/shown purely
          by a CSS scroll-driven animation — NO JS, because Safari 26
          samples fixed elements at render time and ignores later
          JS-driven colour/class changes. Full explainer in cc-pdp.css.
       2. The theme-color meta swap below covers iOS <= 18, which still
          honours the meta tag (cc-marquee-at-top is kept on <body> only
          as a styling hook).
       The boundary check uses the ink block's real rect (banner, or the
       header on the dark PDP), not a scroll offset, so it stays correct
       if anything above it changes height. */
    if (topBlockEl) {
      var atTop = topBlockEl.getBoundingClientRect().bottom > 0;
      if (atTop !== marqueeAtTop) {
        marqueeAtTop = atTop;
        document.body.classList.toggle('cc-marquee-at-top', atTop);
        setTopColor(atTop ? '#111412' : topAwayColor);
      }
    }
    updateAddBarVisibility();
  }
  /* theme-color meta drives the status bar on iOS <= 18 ONLY. iOS 26
     ignores this meta and is handled entirely in CSS by the
     scroll-driven .cc-tint-strip-top — see the "TOP TINT STRIP"
     explainer + FAILED APPROACHES log in cc-pdp.css before touching
     anything here. Do NOT try to drive the iOS 26 status bar from JS:
     Safari 26 samples colours once at render time and ignores every
     later JS-driven colour/class/display change (that caused both the
     "stuck white" bug and the stale dark gradient smear). */
  function setTopColor(color) {
    document.querySelectorAll('meta[name="theme-color"]').forEach(function (m) {
      m.setAttribute('content', color);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- gallery ----------
     Huel's carousel behaviour: no wrap-around — prev is disabled on the
     first slide and next on the last, and the pager is a pill for the
     current slide with dots for the rest, each dot a tap target. */
  var track = root.querySelector('[data-cc-gallery-track]');
  var slides = track ? track.children.length : 0;
  var dotsEl = root.querySelector('[data-cc-gallery-dots]');
  var prevBtns = root.querySelectorAll('[data-cc-gallery-prev]');
  var nextBtns = root.querySelectorAll('[data-cc-gallery-next]');
  if (dotsEl && slides > 1) {
    var dotsHtml = '';
    for (var d = 0; d < slides; d++) {
      dotsHtml += '<button type="button" class="cc-gallery__dot" role="tab" data-cc-gallery-dot="' + d + '" aria-label="Image ' + (d + 1) + ' of ' + slides + '" aria-selected="false"></button>';
    }
    dotsEl.innerHTML = dotsHtml;
    dotsEl.querySelectorAll('[data-cc-gallery-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        journey.count('gallery_dots');
        goSlide(parseInt(dot.getAttribute('data-cc-gallery-dot'), 10));
      });
    });
  }
  function goSlide(i) {
    if (!track || slides === 0) return;
    state.slide = Math.max(0, Math.min(slides - 1, i));
    journey.slide(state.slide);
    track.style.transform = 'translateX(-' + state.slide * 100 + '%)';
    var atStart = state.slide === 0;
    var atEnd = state.slide === slides - 1;
    prevBtns.forEach(function (b) { b.setAttribute('aria-disabled', atStart ? 'true' : 'false'); });
    nextBtns.forEach(function (b) { b.setAttribute('aria-disabled', atEnd ? 'true' : 'false'); });
    if (dotsEl) {
      dotsEl.querySelectorAll('[data-cc-gallery-dot]').forEach(function (dot, idx) {
        dot.setAttribute('aria-selected', idx === state.slide ? 'true' : 'false');
      });
    }
    syncGallerySlides();
  }
  function slideIndexOf(el) {
    if (!track) return 0;
    while (el && el.parentNode !== track) el = el.parentNode;
    return el ? Array.prototype.indexOf.call(track.children, el) : -1;
  }
  /* Nothing but slide 1's poster loads before the page has (galleryReady),
     so the first paint isn't sharing bandwidth. After that the active slide
     and the next photo load; videos and the 1.5–2 MB in-app fallback WebPs
     only load once their own slide is showing. */
  var galleryReady = false;
  function syncGallerySlides() {
    if (!track) return;
    if (galleryReady) {
      track.querySelectorAll('[data-src]').forEach(function (el) {
        var i = slideIndexOf(el);
        var heavy = el.tagName === 'VIDEO' || el.hasAttribute('data-cc-fallback');
        if (i !== state.slide && (heavy || i !== state.slide + 1)) return;
        el.src = el.getAttribute('data-src');
        el.removeAttribute('data-src');
      });
    }
    if (typeof playActiveVideo === 'function') playActiveVideo();
  }
  prevBtns.forEach(function (b) {
    b.addEventListener('click', function () { journey.count('gallery_arrows'); goSlide(state.slide - 1); });
  });
  nextBtns.forEach(function (b) {
    b.addEventListener('click', function () { journey.count('gallery_arrows'); goSlide(state.slide + 1); });
  });
  /* In-app browsers (TikTok, Instagram) often ignore the autoplay
     attribute and only honour a scripted play() — some only after the
     first user gesture — so start it from script and retry on the first
     touch/scroll if the webview refused. */
  /* TikTok's webview refuses inline video outright, so there (and anywhere
     play() is rejected after a gesture) the slide becomes an animated WebP. */
  var inAppBrowser = /BytedanceWebview|musical_ly|trill_|TikTok|Instagram|FBAN|FBAV/i.test(navigator.userAgent || '');
  function swapToImage(v) {
    var src = v.getAttribute('data-fallback-src');
    if (!src || !v.parentNode) return;
    var img = document.createElement('img');
    img.className = v.className;
    img.setAttribute('data-src', src);
    img.setAttribute('data-cc-fallback', '');
    img.alt = v.getAttribute('aria-label') || '';
    img.setAttribute('decoding', 'async');
    v.parentNode.replaceChild(img, v);
    syncGallerySlides();
  }
  if (inAppBrowser) {
    root.querySelectorAll('[data-cc-gallery-video]').forEach(swapToImage);
  }
  var galleryVideos = root.querySelectorAll('[data-cc-gallery-video]');
  var gestured = false;
  var playActiveVideo = null;
  if (galleryVideos.length) {
    var playAll = function () {
      galleryVideos.forEach(function (v) {
        if (!v.isConnected || v.hasAttribute('data-src')) return;
        if (slideIndexOf(v) !== state.slide) {
          if (!v.paused) v.pause();
          return;
        }
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        if (!v.paused) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () { if (gestured) swapToImage(v); });
      });
    };
    playActiveVideo = playAll;
    var gestureEvents = ['touchstart', 'pointerdown', 'scroll', 'click'];
    var onGesture = function () {
      gestured = true;
      playAll();
      gestureEvents.forEach(function (ev) { window.removeEventListener(ev, onGesture, true); });
    };
    gestureEvents.forEach(function (ev) { window.addEventListener(ev, onGesture, { capture: true, passive: true }); });
    playAll();
    galleryVideos.forEach(function (v) {
      v.addEventListener('loadeddata', playAll, { once: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) playAll();
    });
  }
  function markGalleryReady() {
    if (galleryReady) return;
    galleryReady = true;
    syncGallerySlides();
  }
  if (document.readyState === 'complete') setTimeout(markGalleryReady, 0);
  else window.addEventListener('load', markGalleryReady, { once: true });
  /* a slow third-party script shouldn't hold the video back indefinitely */
  setTimeout(markGalleryReady, 4000);
  ['touchstart', 'pointerdown'].forEach(function (ev) {
    window.addEventListener(ev, markGalleryReady, { once: true, passive: true, capture: true });
  });
  var gallery = root.querySelector('[data-cc-gallery]');
  if (gallery) {
    var touchX = null;
    gallery.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) {
        journey.count('gallery_swipes');
        goSlide(state.slide + (dx < 0 ? 1 : -1));
      }
      touchX = null;
    }, { passive: true });
  }

  /* ---------- flavour picker ----------
     The picker mirrors the bag: tile quantities are synced from the cart
     on load and after every cart mutation (syncPickerFromCart), so a
     returning visitor sees their bag reflected in the grid. Stepping the
     tiles stages a new TARGET state; the sticky button then applies the
     difference to the cart. */
  function pickerCount() {
    return Object.values(state.picker).reduce(function (a, b) { return a + b; }, 0);
  }
  function cartQty(variantId) {
    var items = (state.cart && state.cart.items) || [];
    return items.reduce(function (a, it) {
      return a + (String(it.variant_id) === String(variantId) ? it.quantity : 0);
    }, 0);
  }
  function syncPickerFromCart() {
    products.forEach(function (p) { state.picker[p.variantId] = cartQty(p.variantId); });
    renderTiles();
    renderAddBar();
  }
  /* Staged changes vs the live cart. */
  function pickerDiff() {
    var addedLines = [];
    var reduced = [];
    products.forEach(function (p) {
      var target = state.picker[p.variantId] || 0;
      var current = cartQty(p.variantId);
      if (target > current) {
        addedLines.push({ id: p.variantId, name: p.name, priceCents: p.price, quantity: target - current });
      } else if (target < current) {
        reduced.push({ id: p.variantId, quantity: target });
      }
    });
    return { addedLines: addedLines, reduced: reduced, dirty: addedLines.length > 0 || reduced.length > 0 };
  }
  function pickerTotal() {
    return products.reduce(function (a, p) { return a + state.picker[p.variantId] * p.price; }, 0);
  }
  function pickerSaving() {
    return products.reduce(function (a, p) {
      return a + state.picker[p.variantId] * Math.max(0, p.list - p.price);
    }, 0);
  }

  /* Rows (snippets/cc-flavour-row.liquid) keep the tile-era data-cc-tile*
     hooks; .cc-row--selected flips the stepper from the lone plus to
     [−] n [+]. The picker head's right-hand text is a static fact
     ("10 COOKIES PER BAG", in the Liquid); the running tally is the
     footer's TOTAL row. */
  function renderTiles() {
    root.querySelectorAll('[data-cc-tile]').forEach(function (tile) {
      var id = tile.getAttribute('data-variant-id');
      var qty = state.picker[id] || 0;
      tile.classList.toggle('cc-row--selected', qty > 0);
      var qtyEls = tile.querySelectorAll('[data-cc-tile-qty]');
      qtyEls.forEach(function (el) { el.textContent = qty; });
    });
  }

  var addBar = root.querySelector('[data-cc-addbar]');
  var addBtn = root.querySelector('[data-cc-add]');
  var pickAddBtn = root.querySelector('[data-cc-pick-add]');
  var addMicro = root.querySelector('[data-cc-add-micro]');
  var addMicroTail = root.querySelector('[data-cc-add-micro-tail]');
  var cutoffEl = root.querySelector('[data-cc-cutoff]');
  var pickerGrid = root.querySelector('[data-cc-picker-list]');

  /* ---------- bake cutoff countdown + journey strip ----------
     A true deadline: orders placed before the cutoff join the next bake.
     Cutoff hour and bake days come from section settings. */
  var DAY_KEYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  var DAY_FULL = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
  var cutoffHour = typeof config.cutoffHour === 'number' ? config.cutoffHour : 0;
  var bakeDaysSet = (config.bakeDays || 'MON,TUE,WED,THU,FRI,SAT')
    .split(',').map(function (s) { return s.trim().slice(0, 3).toUpperCase(); });

  function nextBake(now) {
    for (var i = 1; i <= 8; i++) {
      var bake = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
      if (bakeDaysSet.indexOf(DAY_KEYS[bake.getDay()]) === -1) continue;
      /* Cutoff sits the evening before the bake; hour 0 means midnight,
         i.e. the very start of the bake day itself. */
      var cutoff = cutoffHour === 0
        ? new Date(bake.getFullYear(), bake.getMonth(), bake.getDate(), 0, 0, 0)
        : new Date(bake.getFullYear(), bake.getMonth(), bake.getDate() - 1, cutoffHour, 0, 0);
      if (cutoff > now) return { bake: bake, cutoff: cutoff };
    }
    return null;
  }

  function isTomorrow(d, now) {
    var t = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    return d.getFullYear() === t.getFullYear() && d.getMonth() === t.getMonth() && d.getDate() === t.getDate();
  }

  var bakeInfo = null;
  function bakeWord() {
    if (!bakeInfo) return 'TOMORROW\u2019S';
    return isTomorrow(bakeInfo.bake, new Date())
      ? 'TOMORROW\u2019S'
      : DAY_FULL[bakeInfo.bake.getDay()] + '\u2019S';
  }

  function tickCutoff() {
    var now = new Date();
    bakeInfo = nextBake(now);
    if (!bakeInfo) {
      if (cutoffEl) cutoffEl.textContent = '';
      return;
    }
    if (cutoffEl) {
      var ms = bakeInfo.cutoff - now;
      var h = Math.floor(ms / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      cutoffEl.textContent = 'ORDER IN ' + (h > 0 ? h + 'H ' + m + 'M' : m + 'M') + ' ';
    }
    /* Journey strip labels derive from the same cutoff. */
    var orderEl = root.querySelector('[data-cc-journey-order]');
    var bakedEl = root.querySelector('[data-cc-journey-baked]');
    var postedEl = root.querySelector('[data-cc-journey-posted]');
    var doorEl = root.querySelector('[data-cc-journey-door]');
    var short = DAY_KEYS[bakeInfo.bake.getDay()];
    var arrival = new Date(bakeInfo.bake.getFullYear(), bakeInfo.bake.getMonth(), bakeInfo.bake.getDate() + 1);
    /* A midnight cutoff lands at 00:00 of the next day; step back a minute
       so the label names the day people actually order by. */
    var cutoffDay = DAY_KEYS[new Date(bakeInfo.cutoff - 60000).getDay()];
    if (orderEl) orderEl.innerHTML = isTomorrow(bakeInfo.bake, now) ? 'ORDER<br>TONIGHT' : 'ORDER BY<br>' + cutoffDay;
    if (bakedEl) bakedEl.innerHTML = 'BAKED<br>' + short + ' 6AM';
    if (postedEl) postedEl.innerHTML = 'POSTED<br>' + short + ' 11AM';
    /* "DOOR" not "YOUR DOOR": the longer label wrapped to three lines and
       clipped at the section edge on 390px viewports. */
    if (doorEl) doorEl.innerHTML = 'DOOR<br>' + DAY_FULL[arrival.getDay()];
  }
  tickCutoff();
  window.setInterval(function () { if (frozen()) return; tickCutoff(); renderAddBar(); }, 60000);

  /* Marquee tap: the reviews section when the page has one, otherwise the
     info tabs with Delivery opened (the marquee is a delivery promo).
     70px header offset. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-cc-jump-reviews]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector('.cc-reviews') || document.querySelector('.cc-info');
      var delivery = target && target.querySelector('[data-cc-info-delivery]');
      if (delivery) delivery.open = true;
      if (!target) {
        /* shell pages have no reviews section — the promo banner leads to
           the cookies PDP instead */
        window.location.href = '/products/cookies';
        return;
      }
      var y = target.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  });

  /* Sticky bar stays hidden until a flavour is picked (or the bag already
     holds something). The old light bar also surfaced once the picker had
     been scrolled past, as an inert "pick your flavours" prompt; the dark
     footer carries totals and a meter, so it waits for a real item. */
  var addBarShown = false;
  function cartCount() {
    return state.cart ? state.cart.item_count : 0;
  }
  function updateAddBarVisibility() {
    if (!addBar) return;
    var show = pickerCount() > 0 || cartCount() > 0;
    if (!show && pickerGrid && !addBar.classList.contains('cc-foot')) {
      // Show as soon as the bottom of the flavour picker grid comes into view.
      show = pickerGrid.getBoundingClientRect().bottom <= window.innerHeight;
    }
    if (show !== addBarShown) {
      addBarShown = show;
      addBar.classList.toggle('cc-addbar--visible', show);
    }
  }
  function renderAddBar() {
    var diff = pickerDiff();
    if (!addBtn) {
      /* no pinned footer bar in the markup — the pill is the only CTA */
      renderPickAdd(diff);
      return;
    }
    if (!diff.dirty && cartCount() > 0) {
      // Grid matches the bag — act as a "view bag" button.
      var n = cartCount();
      addBtn.textContent = 'VIEW BAG (' + n + ') \u2014 ' + gbp(state.cart.total_price);
      addBtn.classList.remove('cc-add--inert');
      addBtn.removeAttribute('aria-disabled');
      if (addMicroTail) addMicroTail.textContent = 'TO MAKE ' + bakeWord() + ' BAKE \u00b7 OR PICK MORE FLAVOURS';
    } else if (!diff.dirty) {
      addBtn.textContent = 'PICK YOUR FLAVOURS ABOVE';
      addBtn.classList.add('cc-add--inert');
      addBtn.setAttribute('aria-disabled', 'true');
      if (addMicroTail) addMicroTail.textContent = 'TO MAKE ' + bakeWord() + ' BAKE';
    } else if (diff.reduced.length > 0) {
      // Some tiles were stepped below what's in the bag — generic update CTA.
      addBtn.textContent = 'UPDATE BAG \u2014 ' + gbp(pickerTotal());
      addBtn.classList.remove('cc-add--inert');
      addBtn.removeAttribute('aria-disabled');
      if (addMicroTail) addMicroTail.textContent = 'TO MAKE ' + bakeWord() + ' BAKE';
    } else {
      var count = diff.addedLines.reduce(function (a, l) { return a + l.quantity; }, 0);
      var addTotal = diff.addedLines.reduce(function (a, l) { return a + l.priceCents * l.quantity; }, 0);
      /* the footer's TOTAL row already carries the amount, so the button
         reads "ADD TO BAG — £9.99" (what this tap adds) as in the mockup;
         the old bar without a total row spelled out the flavour count */
      addBtn.textContent = footTotalEl
        ? 'ADD TO BAG \u2014 ' + gbp(addTotal)
        : 'ADD ' + count + (count === 1 ? ' FLAVOUR' : ' FLAVOURS') + ' TO BAG \u2014 ' + gbp(addTotal);
      addBtn.classList.remove('cc-add--inert');
      addBtn.removeAttribute('aria-disabled');
      if (addMicroTail) {
        var tailSaving = framing === 'quiet' ? 0 : pickerSaving();
        addMicroTail.textContent = tailSaving > 0
          ? 'TO MAKE ' + bakeWord() + ' BAKE \u00b7 YOU\u2019RE SAVING ' + gbp(tailSaving)
          : 'TO MAKE ' + bakeWord() + ' BAKE';
      }
    }
    renderPickAdd(diff);
    renderFoot();
    updateAddBarVisibility();
  }

  /* Pill under the picker list: same staged diff as the footer button,
     sentence-case labels. Grey and inert until a row is stepped. */
  function renderPickAdd(diff) {
    if (!pickAddBtn) return;
    var label, inert = false;
    if (!diff.dirty && cartCount() > 0) {
      label = 'View bag (' + cartCount() + ') \u00b7 ' + gbp(state.cart.total_price);
    } else if (!diff.dirty) {
      label = 'Choose flavour';
      inert = true;
    } else if (diff.reduced.length > 0) {
      label = 'Update bag \u00b7 ' + gbp(pickerTotal());
    } else {
      var addTotal = diff.addedLines.reduce(function (a, l) { return a + l.priceCents * l.quantity; }, 0);
      label = 'Add to basket | ' + gbp(addTotal);
    }
    var labelEl = pickAddBtn.querySelector('[data-cc-pick-add-label]');
    (labelEl || pickAddBtn).textContent = label;
    pickAddBtn.classList.toggle('cc-pick-add--inert', inert);
    if (inert) pickAddBtn.setAttribute('aria-disabled', 'true');
    else pickAddBtn.removeAttribute('aria-disabled');
  }

  /* ---------- pinned footer numbers (dark PDP) ----------
     Postage row, TOTAL and the barcode meter follow the PICKER — the
     staged bag — so each stepper tap moves them before anything is sent
     to the cart. Once the picker mirrors the bag (the resting state after
     an add) the figures equal the cart's, so page footer and drawer
     footer always agree. Same postage rules as renderCart(). */
  var footTotalEl = root.querySelector('[data-cc-foot-total]');
  var footPostageEl = root.querySelector('[data-cc-foot-postage]');
  var footGapEl = root.querySelector('[data-cc-foot-gap]');
  var footWasEl = root.querySelector('[data-cc-foot-postage-was]');
  var footMeterEl = root.querySelector('[data-cc-foot-meter]');
  var POSTAGE_CENTS = 399;
  function freePostFrom() {
    /* the cart drawer's section setting is the single source of truth;
       0 means there is no free delivery, so the threshold is never reached */
    var el = document.querySelector('[data-cc-meter][data-threshold-cents]');
    if (!el) return 1300;
    var cents = parseFloat(el.getAttribute('data-threshold-cents'));
    return cents > 0 ? cents : Infinity;
  }
  function renderFoot() {
    if (!footTotalEl) return;
    var subtotal = pickerTotal();
    var threshold = freePostFrom();
    var free = subtotal >= threshold;
    var postage = free ? 0 : POSTAGE_CENTS;
    var gap = Math.max(0, threshold - subtotal);
    var atGap = !free && subtotal > 0 && gap > 0 && isFinite(gap);
    footTotalEl.textContent = gbp(subtotal + (subtotal > 0 ? postage : 0));
    if (footPostageEl) footPostageEl.textContent = free ? 'FREE' : gbp(POSTAGE_CENTS);
    if (footWasEl) footWasEl.textContent = gbp(POSTAGE_CENTS);
    if (footGapEl) footGapEl.textContent = atGap ? 'SPEND ' + gbp(gap) + ' FOR FREE POST' : '';
    var row = footPostageEl && footPostageEl.closest('.cc-foot__row');
    if (row) {
      row.classList.toggle('cc-foot__row--free', free);
      row.classList.toggle('cc-foot__row--gap', atGap);
    }
  }

  root.querySelectorAll('[data-cc-tile]').forEach(function (tile) {
    var id = tile.getAttribute('data-variant-id');
    tile.addEventListener('click', function () {
      if ((state.picker[id] || 0) === 0) {
        journey.step('flavour_tap');
        state.picker[id] = 1;
        renderTiles(); renderAddBar();
      }
    });
    var inc = tile.querySelector('[data-cc-tile-inc]');
    var dec = tile.querySelector('[data-cc-tile-dec]');
    if (inc) inc.addEventListener('click', function (e) {
      e.stopPropagation();
      journey.step('flavour_tap');
      state.picker[id] = (state.picker[id] || 0) + 1;
      renderTiles(); renderAddBar();
    });
    if (dec) dec.addEventListener('click', function (e) {
      e.stopPropagation();
      state.picker[id] = Math.max(0, (state.picker[id] || 0) - 1);
      renderTiles(); renderAddBar();
    });
  });

  /* ---------- cart API ---------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.cart = cart;
        renderCart();
        syncPickerFromCart();
        refreshExpress();
        return cart;
      });
  }

  /* Express pay (spec 31b): Shopify's accelerated checkout components in
     the drawer footer don't always initialise inside drawers (the known
     Apple Pay gotcha) and must reflect the live cart. Re-fetch the drawer
     section via the Section Rendering API and swap the wrapper so the
     buttons re-mount against the current cart state. */

  /* Shopify offers NO supported way to choose which wallets render —
     every eligible one (Shop Pay, Apple Pay, PayPal, G Pay…) is output
     and four of them stack into a wall of buttons on mobile. The wallet
     list, however, is passed to the component through the plain
     `wallet-configs` HTML attribute (outside the closed shadow DOM), so
     we trim it to the two wallets the design wants before the component
     initialises. Two buttons fit Shopify's horizontal row layout, giving
     the intended half-and-half row. If Shopify ever changes the attribute
     format, JSON.parse throws, we leave the stock rendering, and the
     44px overflow clip on .cc-express still caps it to one row.
     Array order = render order: Apple Pay left, Shop Pay right. */
  var EXPRESS_WALLETS = ['apple_pay', 'shop_pay'];
  function filterExpressWallets(scope) {
    var el = scope.querySelector('shopify-accelerated-checkout-cart');
    if (!el) return;
    var raw = el.getAttribute('wallet-configs');
    if (!raw) return;
    try {
      var configs = JSON.parse(raw);
      if (!Array.isArray(configs)) return;
      var kept = configs.filter(function (c) {
        return c && EXPRESS_WALLETS.indexOf(c.name) !== -1;
      });
      kept.sort(function (a, b) {
        return EXPRESS_WALLETS.indexOf(a.name) - EXPRESS_WALLETS.indexOf(b.name);
      });
      if (!kept.length) return;
      var next = JSON.stringify(kept);
      if (next === JSON.stringify(configs)) return;
      /* swap in a clone so an already-initialised component re-upgrades
         against the trimmed list */
      var clone = el.cloneNode(true);
      clone.setAttribute('wallet-configs', next);
      el.replaceWith(clone);
    } catch (_) { /* unknown format — leave Shopify's default */ }
  }
  filterExpressWallets(document);

  function refreshExpress() {
    var wrap = document.querySelector('[data-cc-express]');
    if (!wrap) return;
    var sectionEl = wrap.closest('.shopify-section');
    if (!sectionEl || !sectionEl.id) return;
    var sectionId = sectionEl.id.replace(/^shopify-section-/, '');
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cc-express]');
        var current = document.querySelector('[data-cc-express]');
        if (fresh && current) {
          filterExpressWallets(fresh);
          current.replaceWith(fresh);
        }
      })
      .catch(function () { /* express row is progressive enhancement */ });
  }
  function cartAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add failed');
      return r.json();
    });
  }
  /* Cart update (Ajax API): discount code and/or attributes. Used for the
     second-bag offer so the code only ever lands via the drawer upsell,
     and to stamp the cart so the order can be tagged afterwards. */
  function cartUpdate(payload) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      return r.json();
    });
  }
  function cartApplyCode(code) { return cartUpdate({ discount: code }); }
  /* Order-tagging breadcrumbs. Underscore-prefixed attributes are hidden
     from the customer but land on the order as note attributes; the
     cc-order-tagger worker turns them into order tags on orders/create. */
  var ATTR_SHOWN = '_second_bag_offer_shown';
  var ATTR_TAKEN = '_second_bag_upsell';
  var ATTR_FLAVOUR = '_second_bag_upsell_flavour';
  function cartChange(variantId, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: String(variantId), quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart change failed');
      return r.json();
    });
  }
  /* Streamers: fired once when the second-bag upsell lands. ~50 ribbons
     shoot up from the bottom centre of the drawer and tumble back down.
     Plain DOM + rAF, ~1.4s, nothing left in the DOM afterwards. Skipped
     for prefers-reduced-motion. */
  function fireStreamers(host) {
    if (!host) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var W = host.clientWidth || 390, H = host.clientHeight || 800;
    var layer = document.createElement('div');
    layer.className = 'cc-streamers';
    layer.setAttribute('aria-hidden', 'true');
    var PAL = ['#529666', '#385e43', '#a7d7b3', '#f3e6c8', '#b5854a', '#1A2028'];
    var N = 50, ps = [], i, el;
    for (i = 0; i < N; i++) {
      var a = (-125 + Math.random() * 70) * Math.PI / 180;
      var sp = 1500 + Math.random() * 1000;
      var w = 4 + Math.random() * 3;
      var ribbon = Math.random() < 0.66;
      el = document.createElement('i');
      el.style.width = w + 'px';
      el.style.height = (ribbon ? w * 2.6 : w * 1.5) + 'px';
      el.style.background = PAL[Math.floor(Math.random() * PAL.length)];
      layer.appendChild(el);
      ps.push({ el: el, x: W / 2, y: H + 10, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, w: w, ribbon: ribbon,
        rot: Math.random() * 360, rv: (Math.random() - 0.5) * 1440, ph: Math.random() * 6.28, delay: Math.random() * 0.06 });
    }
    host.appendChild(layer);
    var LIFE = 1.5, G = 1500, DRAG = 0.988, start = null, last = null;
    function frame(now) {
      if (start === null) { start = now; last = now; }
      var t = (now - start) / 1000, dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (t > LIFE) { if (layer.parentNode) layer.parentNode.removeChild(layer); return; }
      var k = t / LIFE, op = k < 0.7 ? 1 : 1 - (k - 0.7) / 0.3;
      var f = Math.pow(DRAG, dt * 60);
      for (var j = 0; j < ps.length; j++) {
        var p = ps[j];
        if (t < p.delay) continue;
        p.vx *= f; p.vy = p.vy * f + G * dt;
        p.x += p.vx * dt; p.y += p.vy * dt; p.rot += p.rv * dt;
        var wob = p.ribbon ? Math.abs(Math.cos(t * 9 + p.ph)) : 1;
        p.el.style.transform = 'translate(' + (p.x - p.w / 2) + 'px,' + p.y + 'px) rotate(' + p.rot + 'deg) scaleX(' + (0.15 + 0.85 * wob) + ')';
        p.el.style.opacity = op;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function broadcast() {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state.cart, source: 'cc-pdp' } }));
    } catch (_) {}
  }

  /* ---------- ad attribution (TikTok/Meta via the events Worker) ----------
     Fires AddToCart / InitiateCheckout through the same consent-gated
     pipeline as PageView/ViewContent (snippets/tiktok-server-events.liquid).
     Tracking failures must never break the shop. */
  function trackEvent(eventName, lines) {
    try {
      if (typeof window.__ccTTServerEvent !== 'function') return;
      var contents = lines.map(function (l) {
        return {
          content_id: String(l.id),
          content_type: 'product',
          content_name: l.name,
          quantity: l.quantity,
          price: l.priceCents / 100
        };
      });
      var value = lines.reduce(function (a, l) { return a + l.priceCents * l.quantity; }, 0) / 100;
      var eventId = (typeof window.__ccGenerateEventId === 'function') ? window.__ccGenerateEventId() : null;
      var props = {
        content_id: contents.length ? contents[0].content_id : '',
        content_name: contents.length ? contents[0].content_name : '',
        contents: contents,
        content_type: 'product',
        value: value,
        currency: 'GBP'
      };
      if (typeof ttq !== 'undefined') {
        ttq.track(eventName, props, eventId ? { event_id: eventId } : undefined);
      }
      window.__ccTTServerEvent(eventName, props, { event_id: eventId });
    } catch (e) { /* ignore */ }
  }
  function cartLines() {
    var items = (state.cart && state.cart.items) || [];
    return items.map(function (it) {
      return {
        id: it.variant_id,
        name: it.product_title || it.title || '',
        priceCents: it.final_price,
        quantity: it.quantity
      };
    });
  }

  /* Tag the cart so TikTok-first-touch orders are identifiable in admin
     (mirrors what the old bundle builder did). */
  function tagCartFirstTouch() {
    try {
      var ft = (typeof window.__ccGetTikTokFirstTouch === 'function') ? window.__ccGetTikTokFirstTouch() : null;
      if (!ft) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          attributes: {
            '_first_touch': 'tiktok',
            '_tiktok_first_visit': ft.date || '',
            '_tiktok_campaign': ft.campaign || ''
          },
          note: 'First touch: TikTok (' + (ft.date || 'unknown date') + ')'
        })
      }).catch(function () {});
    } catch (e) { /* ignore */ }
  }

  /* ---------- sticky add ----------
     The picker holds the TARGET bag state (synced from the cart), so the
     button applies the difference: new quantities are added via add.js,
     reduced tiles are set absolutely via change.js. fetchCart() then
     re-syncs the grid so tiles and bag always agree. */
  var busy = false;
  /* Pill loading state: label out, ring in. Held for at least
     PICK_BUSY_MIN so a fast cart response never reads as a flicker. */
  var PICK_BUSY_MIN = 400;
  function setPickBusy(on) {
    if (!pickAddBtn) return;
    pickAddBtn.classList.toggle('cc-pick-add--busy', on);
    if (on) pickAddBtn.setAttribute('aria-busy', 'true');
    else pickAddBtn.removeAttribute('aria-busy');
  }
  function holdUntil(startedAt, minMs) {
    var wait = Math.max(0, minMs - (Date.now() - startedAt));
    return new Promise(function (resolve) { window.setTimeout(resolve, wait); });
  }
  function applyPicker() {
    if (busy) return;
    var diff = pickerDiff();
    if (!diff.dirty) {
      if (cartCount() > 0) openDrawer();
      return;
    }
    busy = true;
    journey.step('add_click');
    var startedAt = Date.now();
    setPickBusy(true);
    var step = Promise.resolve();
    if (diff.addedLines.length > 0) {
      step = step.then(function () {
        return cartAdd(diff.addedLines.map(function (l) { return { id: l.id, quantity: l.quantity }; }));
      });
    }
    diff.reduced.forEach(function (r) {
      step = step.then(function () { return cartChange(r.id, r.quantity); });
    });
    step
      .then(function () { return fetchCart(); })
      .then(function () {
        if (diff.addedLines.length > 0) {
          journey.step('added');
          trackEvent('AddToCart', diff.addedLines);
          tagCartFirstTouch();
        }
        return holdUntil(startedAt, PICK_BUSY_MIN);
      })
      .then(function () {
        openDrawer();
        broadcast();
      })
      .catch(function (err) { console.error('[cc-pdp]', err); })
      .finally(function () { busy = false; setPickBusy(false); });
  }
  /* the pinned footer button and the pill under the list do the same thing */
  if (addBtn) addBtn.addEventListener('click', applyPicker);
  if (pickAddBtn) pickAddBtn.addEventListener('click', applyPicker);

  /* ---------- drawer ---------- */
  var drawer = document.querySelector('[data-cc-drawer]');
  var backdrop = document.querySelector('[data-cc-drawer-backdrop]');
  var lastFocus = null;

  /* iOS Safari ignores overflow:hidden for touch scrolling, so freeze the
     body in place while the drawer is open and restore the scroll on close. */
  var lockedScrollY = 0;
  function lockPageScroll() {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('cc-drawer-open');
    /* drawer covers the marquee — status bar goes porcelain while open
       (the strip colour is handled by html.cc-drawer-open in CSS) */
    setTopColor('#f5f6ff');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockPageScroll() {
    document.documentElement.classList.remove('cc-drawer-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    setTopColor(marqueeAtTop ? '#111412' : topAwayColor);
  }

  function openDrawer() {
    if (!drawer) return;
    journey.step('basket_open');
    state.drawerOpen = true;
    lastFocus = document.activeElement;
    drawer.removeAttribute('hidden');
    backdrop && backdrop.removeAttribute('hidden');
    lockPageScroll();
    renderCart();
    refreshExpress();
    requestAnimationFrame(function () {
      drawer.classList.add('cc-drawer--open');
      backdrop && backdrop.classList.add('cc-drawer-backdrop--open');
      drawer.focus({ preventScroll: true });
    });
  }
  function closeDrawer() {
    if (!drawer) return;
    if (state.drawerOpen) {
      journey.step('basket_close');
      journey.bags(cartCount(), 'close');
    }
    state.drawerOpen = false;
    drawer.classList.remove('cc-drawer--open');
    backdrop && backdrop.classList.remove('cc-drawer-backdrop--open');
    unlockPageScroll();
    window.setTimeout(function () {
      if (!state.drawerOpen) {
        drawer.setAttribute('hidden', '');
        backdrop && backdrop.setAttribute('hidden', '');
      }
    }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* Stop drawer touch scrolling from chaining into the page: only the list
     area scrolls, and only when it actually has overflow. */
  if (drawer) {
    var drawerScroller = drawer.querySelector('.cc-drawer__scroll');
    drawer.addEventListener('touchmove', function (e) {
      if (!drawerScroller || !drawerScroller.contains(e.target) ||
          drawerScroller.scrollHeight <= drawerScroller.clientHeight) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  /* InitiateCheckout fires on the checkout link; the server event uses
     fetch keepalive, so it survives the navigation to /checkout. */
  var checkoutLink = drawer && drawer.querySelector('.cc-drawer__checkout');
  if (checkoutLink) {
    checkoutLink.addEventListener('click', function () {
      journey.step('checkout_click');
      journey.bags(cartCount(), 'checkout');
      journey.send('checkout');
      trackEvent('InitiateCheckout', cartLines());
    });
  }

  document.querySelectorAll('[data-cc-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll('[data-cc-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer();
      /* the empty-bag "PICK YOUR FLAVOURS" link: on the PDP the picker is
         right there after closing, but on shell pages there's nothing to
         pick — go to the cookies page instead. */
      if (el.classList.contains('cc-drawer__empty-link') && !document.querySelector('[data-cc-pdp]')) {
        window.location.href = '/products/cookies';
      }
    });
  });
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.drawerOpen) closeDrawer();
    if (e.key === 'Tab' && state.drawerOpen && drawer) {
      var focusables = drawer.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- all-reviews modal ---------- */
  var rmodal = document.querySelector('[data-cc-rmodal]');
  var rmodalBackdrop = document.querySelector('[data-cc-rmodal-backdrop]');
  var rmodalOpen = false;
  var rmodalLastFocus = null;

  function openRmodal() {
    if (!rmodal || rmodalOpen) return;
    rmodalOpen = true;
    rmodalLastFocus = document.activeElement;
    rmodal.removeAttribute('hidden');
    rmodalBackdrop && rmodalBackdrop.removeAttribute('hidden');
    lockPageScroll();
    requestAnimationFrame(function () {
      rmodal.classList.add('cc-rmodal--open');
      rmodalBackdrop && rmodalBackdrop.classList.add('cc-rmodal-backdrop--open');
      rmodal.focus({ preventScroll: true });
    });
  }
  function closeRmodal() {
    if (!rmodal || !rmodalOpen) return;
    rmodalOpen = false;
    rmodal.classList.remove('cc-rmodal--open');
    rmodalBackdrop && rmodalBackdrop.classList.remove('cc-rmodal-backdrop--open');
    unlockPageScroll();
    window.setTimeout(function () {
      if (!rmodalOpen) {
        rmodal.setAttribute('hidden', '');
        rmodalBackdrop && rmodalBackdrop.setAttribute('hidden', '');
      }
    }, 250);
    if (rmodalLastFocus && rmodalLastFocus.focus) rmodalLastFocus.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-cc-rmodal-open], .cc-reviews__cell').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openRmodal(); });
  });
  document.querySelectorAll('[data-cc-rmodal-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeRmodal(); });
  });

  /* Bottom reviews: flavour chips filter the list in place. Every review is
     in the DOM so the filter is instant and needs no request; at most
     REVS_SHOWN rows are visible at a time so the section never runs long,
     and the rest stay in the reviews dialog. */
  /* FAQ panels: clip to three questions when there are more, with the
     fourth fading out under a reveal button. Per panel, so switching
     category keeps its own state. */
  document.querySelectorAll('[data-cc-faq-panel]').forEach(function (panel) {
    var more = panel.querySelector('[data-cc-faq-more]');
    if (!more) return;
    if (panel.querySelectorAll('[data-cc-faq-item]').length <= 2) return;
    panel.classList.add('cc-faq--clipped');
    more.hidden = false;
    more.addEventListener('click', function () {
      panel.classList.remove('cc-faq--clipped');
      more.setAttribute('aria-expanded', 'true');
      more.hidden = true;
    });
  });

  var revsRoot = document.querySelector('[data-cc-revs]');
  if (revsRoot) {
    var REVS_SHOWN = 5;
    var revsList = revsRoot.querySelector('[data-cc-revs-list]');
    var revsItems = [].slice.call(revsRoot.querySelectorAll('[data-cc-revs-item]'));
    var revsChips = [].slice.call(revsRoot.querySelectorAll('[data-cc-revs-filter]'));
    var revsReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    revsChips.forEach(function (chip, i) { chip.style.setProperty('--i', i); });

    function applyRevsFilter(value) {
      var shown = 0;
      revsItems.forEach(function (item) {
        var match = value === 'all' || item.getAttribute('data-flavour') === value;
        var visible = match && shown < REVS_SHOWN;
        item.hidden = !visible;
        if (visible) {
          /* index among the VISIBLE cards, so the entry stagger stays in
             order after filtering */
          item.style.setProperty('--i', shown);
          shown++;
        }
      });
      revsChips.forEach(function (chip) {
        var on = chip.getAttribute('data-cc-revs-filter') === value;
        chip.classList.toggle('cc-revs__chip--active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* cross-fade: the list blurs out, the rows change while they're
       invisible, then it settles back */
    var revsSwapping = false;
    function swapRevsFilter(value) {
      if (revsReduced || !revsList) { applyRevsFilter(value); return; }
      if (revsSwapping) return;
      revsSwapping = true;
      revsRoot.classList.add('cc-revs--settled');
      revsList.classList.add('cc-revs__list--swap');
      setTimeout(function () { applyRevsFilter(value); }, 245);
      setTimeout(function () {
        revsList.classList.remove('cc-revs__list--swap');
        revsSwapping = false;
      }, 700);
    }

    revsChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.classList.contains('cc-revs__chip--active')) return;
        swapRevsFilter(chip.getAttribute('data-cc-revs-filter'));
      });
    });
    applyRevsFilter('all');

    /* play the entry once, the first time the section is on screen */
    if (!revsReduced && 'IntersectionObserver' in window) {
      var revsSeen = false;
      var revsObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || revsSeen) return;
          revsSeen = true;
          revsObserver.disconnect();
          revsRoot.classList.add('cc-revs--in');
          setTimeout(function () { revsRoot.classList.add('cc-revs--settled'); }, 1100);
        });
      }, { threshold: 0.2 });
      revsObserver.observe(revsRoot);
    }
  }
  if (rmodalBackdrop) rmodalBackdrop.addEventListener('click', closeRmodal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && rmodalOpen) closeRmodal();
    if (e.key === 'Tab' && rmodalOpen && rmodal) {
      var focusables = rmodal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Only the modal's own list may scroll while it is open. */
  if (rmodal) {
    var rmodalScroller = rmodal.querySelector('[data-cc-rmodal-scroll]');
    rmodal.addEventListener('touchmove', function (e) {
      if (!rmodalScroller || !rmodalScroller.contains(e.target) ||
          rmodalScroller.scrollHeight <= rmodalScroller.clientHeight) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  /* ---------- nav drawer (NAV-SPEC 33e/33j) ---------- */
  var nav = document.querySelector('[data-cc-nav]');
  var navBackdrop = document.querySelector('[data-cc-nav-backdrop]');
  var navBurger = document.querySelector('[data-cc-nav-open]');
  var navOpen = false;

  var navDateEl = document.querySelector('[data-cc-nav-date]');
  if (navDateEl) {
    /* live date, `DDD DD MMM` caps, e.g. SAT 05 JUL */
    var navNow = new Date();
    var MONTH_KEYS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    navDateEl.textContent = DAY_KEYS[navNow.getDay()] + ' ' +
      ('0' + navNow.getDate()).slice(-2) + ' ' + MONTH_KEYS[navNow.getMonth()];
  }

  function openNav() {
    if (!nav || navOpen) return;
    navOpen = true;
    nav.removeAttribute('hidden');
    navBackdrop && navBackdrop.removeAttribute('hidden');
    lockPageScroll();
    navBurger && navBurger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      nav.classList.add('cc-nav--open');
      navBackdrop && navBackdrop.classList.add('cc-nav-backdrop--open');
      var closeBtn = nav.querySelector('[data-cc-nav-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
  }
  function closeNav() {
    if (!nav || !navOpen) return;
    navOpen = false;
    nav.classList.remove('cc-nav--open');
    navBackdrop && navBackdrop.classList.remove('cc-nav-backdrop--open');
    unlockPageScroll();
    navBurger && navBurger.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      if (!navOpen) {
        nav.setAttribute('hidden', '');
        navBackdrop && navBackdrop.setAttribute('hidden', '');
      }
    }, 250);
    if (navBurger && navBurger.focus) navBurger.focus({ preventScroll: true });
  }

  if (navBurger) {
    navBurger.addEventListener('click', function (e) { e.preventDefault(); openNav(); });
  }
  document.querySelectorAll('[data-cc-nav-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeNav(); });
  });
  if (navBackdrop) navBackdrop.addEventListener('click', closeNav);
  /* REVIEWS row opens the on-page all-reviews modal. On shell pages the
     modal markup doesn't exist, so navigate to the PDP instead — the
     #reviews hash makes the PDP auto-open the modal on arrival. */
  document.querySelectorAll('[data-cc-nav-reviews]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeNav();
      if (rmodal) {
        window.setTimeout(openRmodal, 260);
      } else {
        window.location.href = '/products/cookies#reviews';
      }
    });
  });

  /* Reviews and FAQ are sections of this page. When the visitor is already
     here, close the menu and scroll rather than reloading the PDP onto its
     own hash — the reload throws away scroll position and flashes the page.
     Elsewhere the href does the work and the browser lands on the anchor. */
  document.querySelectorAll('[data-cc-nav-jump]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var target = document.getElementById(el.getAttribute('data-cc-nav-jump'));
      if (!target) return;
      e.preventDefault();
      closeNav();
      window.setTimeout(function () {
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }, 280);
    });
  });
  if (rmodal && window.location.hash === '#reviews') {
    window.setTimeout(openRmodal, 400);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && navOpen) closeNav();
    if (e.key === 'Tab' && navOpen && nav) {
      var focusables = nav.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- drawer rendering ---------- */
  var bagPills = document.querySelectorAll('[data-cc-bag-count]');
  var itemsEl = drawer && drawer.querySelector('[data-cc-drawer-items]');
  var upsellWrap = drawer && drawer.querySelector('[data-cc-drawer-upsell]');
  var upsellList = drawer && drawer.querySelector('[data-cc-drawer-upsell-list]');
  var upsellLabel = drawer && drawer.querySelector('[data-cc-upsell-label]');
  var upsellHint = drawer && drawer.querySelector('[data-cc-upsell-hint]');
  var upsellNote = drawer && drawer.querySelector('[data-cc-upsell-note]');
  var footerEl = drawer && drawer.querySelector('[data-cc-drawer-footer]');
  var summaryEl = drawer && drawer.querySelector('[data-cc-drawer-summary]');
  var shipEl = drawer && drawer.querySelector('[data-cc-meter]');
  var accentEl = drawer && drawer.querySelector('[data-cc-headline-accent]');
  var subEl = drawer && drawer.querySelector('[data-cc-drawer-sub]');

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* ---------- inline flavour picker ---------- */
  /* Products JSON names are the mono caps used in the bag grid; the serif
     rows want title case ("The Variety Bag"). */
  function titleCase(s) {
    return String(s).toLowerCase().replace(/(^|\s)(\S)/g, function (m, sp, ch) { return sp + ch.toUpperCase(); });
  }
  /* same glyphs as snippets/cc-flavour-row.liquid */
  var ICON_MINUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 4.25a.75.75 0 0 1 .75.75v6.25H19a.75.75 0 0 1 0 1.5h-6.25V19a.75.75 0 0 1-1.5 0v-6.25H5a.75.75 0 0 1 0-1.5h6.25V5a.75.75 0 0 1 .75-.75"/></svg>';

  function renderCart() {
    var cart = state.cart;
    var count = cart ? cart.item_count : 0;
    journey.bags(count);

    /* count badge on the bag icon: hidden while empty */
    bagPills.forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle('cc-header__bag-count--empty', count === 0);
      var btn = el.closest('button');
      if (btn) btn.setAttribute('aria-label', 'Open bag, ' + count + (count === 1 ? ' item' : ' items'));
    });
    if (!drawer) return;

    var items = (cart && cart.items) || [];
    var saving = 0;
    items.forEach(function (it) {
      var p = byVariant(it.variant_id);
      if (p) saving += Math.max(0, p.list - p.price) * it.quantity;
    });

    /* Express delivery: mirrors the store's UK shipping rates (Royal
       Mail Express 24 Tracked £3.99 for £0–£12.99, free from £13 — the
       threshold sits just under two bags).
       The threshold comes from the delivery meter's section setting so
       meter and summary always agree. If the rate changes, update it in
       Settings → Shipping AND the section setting AND the delivery FAQ
       answers AND the promo bar in cc-pdp.liquid / cc-global-shell AND
       POSTAGE_CENTS in renderFoot() above. */
    var POSTAGE_CENTS = 399;
    var FREE_POST_FROM_CENTS = freePostFrom();
    var freePostOn = isFinite(FREE_POST_FROM_CENTS);
    var postageSaved = cart && cart.total_price >= FREE_POST_FROM_CENTS ? POSTAGE_CENTS : 0;
    var totalSaved = saving + postageSaved;

    var empty = count === 0;
    if (footerEl) footerEl.hidden = empty;
    if (summaryEl) summaryEl.hidden = empty;

    /* Second-bag offer, sold from the one-bag state as what the customer
       actually pays more: bag price − any £ off − the postage they stop
       paying (£6.99 − £3.99 = £3 once delivery flips to free at £13).
       Optionally a Shopify Buy X Get Y discount CODE takes DEAL_OFF off
       the extra bag (section setting, 0 = no code). It is not automatic on
       purpose: someone who picks two bags on the PDP has agreed to pay for
       two, so the code is only applied by the drawer, when a customer with
       exactly one bag taps an upsell tile. */
    var subtotal = cart ? cart.total_price : 0;
    var DEAL_OFF = parseInt(drawer.getAttribute('data-cc-deal-off-cents'), 10) || 0;
    var DEAL_CODE = drawer.getAttribute('data-cc-deal-code') || '';
    var useCode = DEAL_OFF > 0 && !!DEAL_CODE;
    var unlocksPost = !!products[0] && subtotal < FREE_POST_FROM_CENTS &&
      subtotal + products[0].price >= FREE_POST_FROM_CENTS;
    var deal = count === 1 && (useCode || unlocksPost);
    /* The code sticks to the cart once applied. If the bag shrinks back to
       one item (or empties) the offer was un-taken, so drop the code —
       otherwise two bags picked fresh from the PDP would inherit it. */
    var hasDealCode = !!(cart && (cart.discount_codes || []).some(function (dc) { return dc.code === DEAL_CODE; }));
    var attrs = (cart && cart.attributes) || {};
    /* With two or more bags the summary (delivery, saving, total) moves
       above the upsell tiles so what they save is the first thing seen;
       the tiles sit below to scroll to. With one bag the tiles stay on
       top — that is where the second-bag offer is sold. */
    var takenFlow = count >= 2;
    if (summaryEl && upsellWrap && summaryEl.parentNode === upsellWrap.parentNode) {
      var par = summaryEl.parentNode;
      if (takenFlow && summaryEl.nextElementSibling !== upsellWrap) par.insertBefore(summaryEl, upsellWrap);
      else if (!takenFlow && upsellWrap.nextElementSibling !== summaryEl) par.insertBefore(summaryEl, upsellWrap.nextSibling);
      summaryEl.classList.toggle('cc-drawer__sum--first', takenFlow);
    }
    if (DEAL_CODE && hasDealCode && count <= 1 && !renderCart.clearingCode) {
      renderCart.clearingCode = true;
      var reset = { discount: '' };
      reset.attributes = {}; reset.attributes[ATTR_TAKEN] = ''; reset.attributes[ATTR_FLAVOUR] = '';
      cartUpdate(reset)
        .then(function () { return fetchCart(); })
        .then(function () { renderCart.clearingCode = false; broadcast(); })
        .catch(function (err) { renderCart.clearingCode = false; console.error('[cc-pdp] deal code clear', err); });
    }
    function dealIncrement(p) {
      var after = subtotal + p.price - DEAL_OFF;
      var wasPost = subtotal >= FREE_POST_FROM_CENTS ? 0 : POSTAGE_CENTS;
      var newPost = after >= FREE_POST_FROM_CENTS ? 0 : POSTAGE_CENTS;
      return p.price - DEAL_OFF + newPost - wasPost;
    }
    function tidy(cents) { return gbp(cents).replace(/\.00$/, ''); }
    var dealP = products[0];
    if (deal && !attrs[ATTR_SHOWN] && !renderCart.stampingShown) {
      renderCart.stampingShown = true;
      var shown = { attributes: {} }; shown.attributes[ATTR_SHOWN] = 'yes';
      cartUpdate(shown).catch(function () {}).then(function () { renderCart.stampingShown = false; if (cart) { cart.attributes = cart.attributes || {}; cart.attributes[ATTR_SHOWN] = 'yes'; } });
    }

    /* headline accent + sub line flip for the empty bag / the offer */
    if (accentEl) accentEl.textContent = empty ? 'empty.' : (accentEl.getAttribute('data-accent') || 'delicious.');
    if (subEl) {
      subEl.textContent = empty
        ? 'Pick a flavour below to get started.'
        : (deal && dealP
          ? (useCode
            ? 'Add a second bag for just ' + tidy(dealIncrement(dealP)) + ' more \u2014 and express delivery\u2019s on us.'
            : 'Add a second bag for ' + gbp(dealP.price) + ' and express delivery\u2019s on us.')
          : (subEl.getAttribute('data-sub') || ''));
    }

    /* Bag rows: the same Huel rows as the PDP picker (.cc-row), always in
       the selected state. − / + write straight to the cart; stepping down
       from 1 lands on 0, which removes the line. */
    if (itemsEl) {
      itemsEl.innerHTML = items.map(function (it) {
        var p = byVariant(it.variant_id);
        var name = titleCase(p ? p.name : (it.product_title || it.title || ''));
        var img = p ? p.img : (it.image || '');
        var hasImg = img && !/pla?ceholder|pladeholder/i.test(img);
        var unit = it.final_line_price / Math.max(1, it.quantity);
        var priceHtml = (framing !== 'quiet' && p && p.list > p.price)
          ? '<s>' + gbp(p.list) + '</s> ' + gbp(p.price)
          : gbp(unit);
        var unitHtml = ' <span class="cc-row__unit">per bag</span>';
        /* the bag the offer landed on: we sold it as "£7 more", so no
           £12.99 (looks full price) and no £9.99 (contradicts the £7) —
           strike the bag price and tag it. With 2+ of the same flavour
           only one is discounted, so keep the per-bag price and just tag. */
        var onOffer = useCode && (it.line_level_discount_allocations || []).some(function (a) {
          return a.amount > 0 && a.discount_application && a.discount_application.title === DEAL_CODE;
        });
        if (onOffer) {
          if (it.quantity === 1) { priceHtml = '<s>' + gbp(p ? p.price : unit) + '</s>'; unitHtml = ''; }
          priceHtml += ' <span class="cc-row__offer">Second-bag offer</span>';
        }
        return '<div class="cc-row cc-row--selected" data-variant-id="' + it.variant_id + '">' +
          '<div class="cc-row__thumb' + (hasImg ? '' : ' cc-row__thumb--blank') + '">' +
          (hasImg ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="52" height="52">' : '') +
          '</div>' +
          '<div class="cc-row__main">' +
          '<div class="cc-row__name">' + esc(name) + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cc-row__size">' + esc(it.variant_title) + '</div>' : '') +
          '<div class="cc-row__price">' + priceHtml + unitHtml + '</div>' +
          '</div>' +
          '<div class="cc-row__step" role="group" aria-label="Quantity of ' + esc(name) + '">' +
          '<button type="button" class="cc-row__btn cc-row__btn--dec" data-cc-qty="' + it.variant_id + '" data-cc-qty-to="' + (it.quantity - 1) + '" aria-label="' + (it.quantity > 1 ? 'Fewer ' : 'Remove ') + esc(name) + '">' + ICON_MINUS + '</button>' +
          '<output class="cc-row__count" aria-live="polite">' + it.quantity + '</output>' +
          '<button type="button" class="cc-row__btn cc-row__btn--inc" data-cc-qty="' + it.variant_id + '" data-cc-qty-to="' + (it.quantity + 1) + '" aria-label="More ' + esc(name) + '">' + ICON_PLUS + '</button>' +
          '</div>' +
          '</div>';
      }).join('');
      itemsEl.querySelectorAll('[data-cc-qty]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var to = parseInt(btn.getAttribute('data-cc-qty-to'), 10);
          if (isNaN(to) || to < 0) return;
          btn.disabled = true;
          cartChange(btn.getAttribute('data-cc-qty'), to)
            .then(function () { return fetchCart(); })
            .then(broadcast)
            .catch(function (err) { console.error('[cc-pdp]', err); });
        });
      });
    }

    /* Free express delivery meter: mint track, green fill, tick badge at
       100%. Copy sits under the bar. Hidden while the bag is empty. */
    if (shipEl) shipEl.hidden = empty || !freePostOn;
    if (shipEl && freePostOn) {
      var fill = shipEl.querySelector('[data-cc-ship-fill]');
      var text = shipEl.querySelector('[data-cc-ship-text]');
      var progress = Math.min(1, subtotal / FREE_POST_FROM_CENTS);
      if (fill) fill.style.width = (progress * 100) + '%';
      var unlocked = subtotal >= FREE_POST_FROM_CENTS;
      shipEl.classList.toggle('cc-ship--unlocked', unlocked);
      if (text) {
        text.innerHTML = unlocked
          ? '<span class="cc-ship__ok"><i aria-hidden="true">&#10003;</i>Free express delivery unlocked</span>'
          : '<b>' + (deal && dealP && subtotal + dealP.price - DEAL_OFF >= FREE_POST_FROM_CENTS
              ? 'Add a second bag and express delivery\u2019s free'
              : 'Spend ' + gbp(FREE_POST_FROM_CENTS - subtotal) + ' more for free express delivery') +
            '</b><span class="cc-ship__cap">' + tidy(FREE_POST_FROM_CENTS) + '</span>';
      }
    }

    /* Upsell rail: flavours NOT in the bag (every flavour when it is
       empty), as swipeable cards. Hides when nothing is missing. */
    if (upsellWrap && upsellList) {
      var missing = products.filter(function (p) {
        return !items.some(function (it) { return String(it.variant_id) === String(p.variantId); });
      });
      var showUpsell = missing.length > 0;
      upsellWrap.hidden = !showUpsell;
      if (upsellLabel) {
        upsellLabel.textContent = empty ? 'Pick your flavours'
          : (deal && dealP
            ? (useCode
              ? 'Add a second bag \u2014 \u00a3' + Math.round((dealP.price - dealIncrement(dealP)) / 100) + ' off'
              : 'Add a second bag \u2014 delivery\u2019s free')
            : 'Add to your order');
      }
      if (upsellHint) upsellHint.hidden = missing.length < 3;
      /* With a code, checkout shows the offer bag discounted and the free
         delivery on a separate line; spell out how that adds up to the
         tiles' "£X more" so nothing at checkout is a surprise. */
      if (upsellNote) {
        var noteOn = showUpsell && deal && !!dealP;
        upsellNote.hidden = !noteOn;
        if (noteOn) {
          var bagNow = dealP.price - DEAL_OFF;
          var inc = dealIncrement(dealP);
          upsellNote.textContent = !useCode
            ? gbp(bagNow) + ' bag \u00b7 saves your ' + gbp(POSTAGE_CENTS) + ' delivery'
            : (inc < bagNow
              ? gbp(bagNow) + ' bag + free express delivery = ' + tidy(inc) + ' more'
              : 'Second bag ' + gbp(bagNow) + ' with the offer');
        }
      }
      upsellWrap.classList.toggle('cc-drawer__upsell--deal', deal);
      if (showUpsell) {
        upsellList.innerHTML = missing.map(function (p) {
          var hasImg = p.img && !/pla?ceholder|pladeholder/i.test(p.img);
          var priceHtml, dealHtml = '', addLabel = 'Add';
          if (deal && !useCode) {
            /* plain bag price on the button; the chip carries the delivery flip */
            priceHtml = '';
            dealHtml = '<div class="cc-ucard__deal">Unlocks free delivery</div>';
            addLabel = 'Add \u00b7 ' + gbp(p.price);
          } else if (deal) {
            /* no price line: the button's increment is the only number, so the
               customer isn't juggling list / discounted / increment at once */
            priceHtml = '';
            /* button carries the real increment (bag − code − postage that
               stops being charged); the chip explains the delivery flip */
            dealHtml = '<div class="cc-ucard__deal">Unlocks free delivery</div>';
            addLabel = 'Add \u00b7 ' + tidy(dealIncrement(p));
          } else {
            priceHtml = (framing !== 'quiet' && p.list > p.price)
              ? '<s>' + gbp(p.list) + '</s> ' + gbp(p.price)
              : gbp(p.price);
          }
          return '<div class="cc-ucard">' +
            '<div class="cc-ucard__img' + (hasImg ? '' : ' cc-ucard__img--blank') + '">' +
            (hasImg ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') +
            '</div>' +
            '<div class="cc-ucard__name">' + esc(titleCase(p.name)) + '</div>' +
            (priceHtml ? '<div class="cc-ucard__price">' + priceHtml + '</div>' : '') +
            dealHtml +
            '<button type="button" class="cc-ucard__add" data-upsell="' + p.variantId + '" aria-label="Add ' + esc(titleCase(p.name)) + '">' + addLabel + '</button>' +
            '</div>';
        }).join('');
        upsellList.querySelectorAll('[data-upsell]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var vid = btn.getAttribute('data-upsell');
            btn.disabled = true;
            btn.textContent = 'Adding\u2026';
            cartAdd([{ id: Number(vid), quantity: 1 }])
              .then(function () {
                /* the offer: this tap was made from the one-bag state */
                if (!deal) return null;
                var taken = { attributes: {} };
                if (useCode) taken.discount = DEAL_CODE;
                taken.attributes[ATTR_TAKEN] = 'yes';
                taken.attributes[ATTR_FLAVOUR] = (byVariant(vid) || {}).name || String(vid);
                return cartUpdate(taken).catch(function (err) { console.error('[cc-pdp] deal code', err); });
              })
              .then(function () { return fetchCart(); })
              .then(function () {
                var p = byVariant(vid);
                if (p) trackEvent('AddToCart', [{ id: p.variantId, name: p.name, priceCents: p.price, quantity: 1 }]);
                tagCartFirstTouch();
                broadcast();
                if (deal) fireStreamers(drawer);
              })
              .catch(function (err) {
                console.error('[cc-pdp]', err);
                btn.disabled = false;
                btn.textContent = 'Add';
              });
          });
        });
      }
    }

    /* Pinned footer: delivery, total, checkout */
    if (!empty && cart) {
      var postage = postageSaved > 0 ? 0 : POSTAGE_CENTS;
      var total = subtotal + postage;
      /* The list-vs-sale saving on every bag plus any discount Shopify
         applied to the lines; total_price is already net of the line
         discounts, so the struck-through total is total + both. */
      var discTotal = 0;
      items.forEach(function (it) { discTotal += it.line_level_total_discount || 0; });
      var combined = (framing !== 'quiet' ? saving : 0) + discTotal;
      if (footerEl) {
        var footPost = footerEl.querySelector('[data-cc-foot-post]');
        if (footPost) {
          footPost.innerHTML = postage === 0
            ? '<s>' + gbp(POSTAGE_CENTS) + '</s> <span class="cc-drawer__sum-green">Free</span>'
            : gbp(postage);
        }
        var footTotal = footerEl.querySelector('[data-cc-foot-total]');
        var footWas = footerEl.querySelector('[data-cc-foot-was]');
        var footSaving = combined;
        if (footTotal) footTotal.textContent = gbp(total);
        if (footWas) {
          footWas.hidden = footSaving <= 0;
          footWas.textContent = gbp(total + footSaving);
        }
      }
    }

    // Keep the sticky bar in sync with the bag (e.g. "VIEW BAG (2)").
    renderAddBar();
  }

  /* ---------- FAQ: category chips + accordion rows ----------
     Tabs pattern: chip = tab, panel = tabpanel. Inactive panels stay in
     the DOM as `hidden` so the FAQPage schema points at real content.
     Left/right arrows move between chips. Inside a panel each row is a
     disclosure button: tapping toggles its answer, and only one row per
     panel is open at a time (Huel's behaviour). */
  var faqChips = Array.prototype.slice.call(root.querySelectorAll('[data-cc-faq-chip]'));
  var faqPanels = Array.prototype.slice.call(root.querySelectorAll('[data-cc-faq-panel]'));
  function showFaq(index, focusChip) {
    faqChips.forEach(function (chip, i) {
      var on = i === index;
      chip.classList.toggle('cc-faqs__chip--active', on);
      chip.setAttribute('aria-selected', on ? 'true' : 'false');
      chip.setAttribute('tabindex', on ? '0' : '-1');
      if (on) {
        if (chip.scrollIntoView) chip.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
        if (focusChip) chip.focus({ preventScroll: true });
      }
    });
    faqPanels.forEach(function (panel, i) {
      if (i === index) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  }
  faqChips.forEach(function (chip, i) {
    chip.setAttribute('tabindex', i === 0 ? '0' : '-1');
    chip.addEventListener('click', function () { showFaq(i, false); });
    chip.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var next = (i + (e.key === 'ArrowRight' ? 1 : faqChips.length - 1)) % faqChips.length;
        showFaq(next, true);
      }
    });
  });
  function setFaqRow(item, open) {
    var toggle = item.querySelector('[data-cc-faq-toggle]');
    var answer = item.querySelector('.cc-faq__a');
    item.classList.toggle('cc-faq__item--open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (answer) {
      if (open) answer.removeAttribute('hidden');
      else answer.setAttribute('hidden', '');
    }
  }
  faqPanels.forEach(function (panel) {
    var items = Array.prototype.slice.call(panel.querySelectorAll('[data-cc-faq-item]'));
    items.forEach(function (item) {
      var toggle = item.querySelector('[data-cc-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var wasOpen = item.classList.contains('cc-faq__item--open');
        items.forEach(function (other) { if (other !== item) setFaqRow(other, false); });
        setFaqRow(item, !wasOpen);
      });
    });
  });

  /* ---------- ingredient spotlight rail ----------
     Steps right forever. The slide set is tripled (clone, real, clone) and
     the scroll position wraps by exactly one set, so the seam never shows
     and the visitor can swipe either way without hitting an end. It rests on
     a card, then glides to the next every few seconds. Under
     prefers-reduced-motion none of this happens: no clones, no timer, just
     the original manual rail with end-stops. */
  var spotTrack = root.querySelector('[data-cc-spot-track]');
  if (spotTrack) {
    var spotControls = root.querySelector('[data-cc-spot-controls]');
    var spotThumb = root.querySelector('[data-cc-spot-thumb]');
    var spotPrev = root.querySelector('[data-cc-spot-prev]');
    var spotNext = root.querySelector('[data-cc-spot-next]');
    var SPOT_GAP = 14; /* matches the gap on .cc-spot__track */
    var spotPeriod = 0;

    function spotSync() {
      var max = spotTrack.scrollWidth - spotTrack.clientWidth;
      var overflows = max > 1;
      if (spotControls) spotControls.hidden = !overflows;
      if (!overflows) return;
      var span = spotPeriod || spotTrack.scrollWidth;
      var ratio = Math.min(spotTrack.clientWidth / span, 1);
      var progress = spotPeriod
        ? ((spotTrack.scrollLeft - spotPeriod) % spotPeriod + spotPeriod) % spotPeriod / spotPeriod
        : spotTrack.scrollLeft / max;
      if (spotThumb) {
        spotThumb.style.width = (ratio * 100) + '%';
        /* the thumb travels the track minus its own width, so it lands
           flush at both ends instead of running off the right */
        spotThumb.style.transform = 'translateX(' + (progress * (100 / ratio - 100)) + '%)';
      }
      spotFocus();
      if (spotPeriod) {
        /* looping: every direction always leads somewhere */
        if (spotPrev) spotPrev.disabled = false;
        if (spotNext) spotNext.disabled = false;
      } else {
        if (spotPrev) spotPrev.disabled = spotTrack.scrollLeft <= 1;
        if (spotNext) spotNext.disabled = spotTrack.scrollLeft >= max - 1;
      }
    }

    /* The slide nearest the left edge of the rail is the one being read, so
       it wears the lead class and CSS grows its photo. Everything else sits
       fractionally smaller, which is what makes the arrival feel like a
       step into focus rather than a slide passing by. */
    function spotFocus() {
      var edge = spotTrack.scrollLeft + 24; /* matches scroll-padding-left */
      var best = null;
      var bestGap = Infinity;
      Array.prototype.forEach.call(spotTrack.children, function (li) {
        var gap = Math.abs(li.offsetLeft - edge);
        if (gap < bestGap) { bestGap = gap; best = li; }
      });
      Array.prototype.forEach.call(spotTrack.children, function (li) {
        li.classList.toggle('cc-spot__slide--lead', li === best);
      });
    }

    /* Native smooth scrolling picks its own duration and it is far too quick
       for a rail that is meant to be read. Drive the glide by hand so the
       move takes as long as it should, easing in and out of the rest.
       Mandatory snap is lifted for the duration — it would fight a
       per-frame scrollLeft — and restored on a slide boundary, where it has
       nothing to correct. */
    var SPOT_GLIDE = 850;
    var spotGlideRaf = 0;

    function spotGlide(dist) {
      if (reduceMotion) { spotTrack.scrollLeft += dist; return; }
      cancelAnimationFrame(spotGlideRaf);
      var from = spotTrack.scrollLeft;
      var t0 = 0;
      spotTrack.style.scrollSnapType = 'none';
      function frame(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / SPOT_GLIDE, 1);
        var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        spotTrack.scrollLeft = from + dist * e;
        if (p < 1) spotGlideRaf = requestAnimationFrame(frame);
        else spotTrack.style.scrollSnapType = '';
      }
      spotGlideRaf = requestAnimationFrame(frame);
    }

    function spotStepSize() {
      var slide = spotTrack.querySelector('.cc-spot__slide');
      return slide ? slide.getBoundingClientRect().width + SPOT_GAP : spotTrack.clientWidth * 0.8;
    }

    function spotStep(dir) {
      var step = spotStepSize();
      /* wrap before the glide, same as the auto advance, so the arrows keep
         working past either end of the middle copy */
      if (spotPeriodSet) {
        if (dir > 0 && spotTrack.scrollLeft + step >= spotPeriod * 2) {
          spotTrack.scrollLeft = spotTrack.scrollLeft - spotPeriod;
        } else if (dir < 0 && spotTrack.scrollLeft - step <= 0) {
          spotTrack.scrollLeft = spotTrack.scrollLeft + spotPeriod;
        }
      }
      spotGlide(dir * step);
    }

    /* hold first: spotHold cancels any in-flight glide, so calling it after
       spotStep would cancel the arrow's own glide on the frame it began */
    if (spotPrev) spotPrev.addEventListener('click', function () { spotHold(); spotStep(-1); });
    if (spotNext) spotNext.addEventListener('click', function () { spotHold(); spotStep(1); });
    spotTrack.addEventListener('scroll', function () { spotWrap(); spotSync(); }, { passive: true });
    window.addEventListener('resize', function () { spotMeasure(); spotSync(); });
    spotSync();

    /* --- auto advance --- */
    var SPOT_EVERY = 2500;    /* rest on a card this long, then move one along */
    var SPOT_RESUME = 2600;   /* a touch parks the timer for this long */
    var spotPeriodSet = false;
    var spotTimer = 0;
    var spotHeld = 0;
    var spotSeen = false;

    function spotMeasure() {
      var first = spotTrack.querySelector('.cc-spot__slide:not([data-cc-spot-clone])');
      var lead = spotTrack.querySelector('[data-cc-spot-clone]');
      if (!first || !lead) return;
      spotPeriod = first.offsetLeft - lead.offsetLeft;
      spotPeriodSet = spotPeriod > 0;
    }

    /* Keep the position inside the middle copy. Both branches move by exactly
       one set width, so the pixels under the viewport are identical before
       and after — the jump is invisible. */
    function spotWrap() {
      if (!spotPeriodSet) return;
      var sl = spotTrack.scrollLeft;
      if (sl >= spotPeriod * 2) spotTrack.scrollLeft = sl - spotPeriod;
      else if (sl <= 0) spotTrack.scrollLeft = sl + spotPeriod;
    }

    function spotHold() {
      spotHeld = Date.now() + SPOT_RESUME;
      /* a hand on the rail wins over an in-flight glide */
      cancelAnimationFrame(spotGlideRaf);
      spotTrack.style.scrollSnapType = '';
    }

    function spotPlay() {
      if (spotTimer || document.hidden) return;
      /* the clock starts on arrival, so the first card gets a full rest in
         front of the visitor rather than half of one */
      spotTimer = setInterval(spotAdvance, SPOT_EVERY);
    }

    function spotPause() {
      clearInterval(spotTimer);
      spotTimer = 0;
      cancelAnimationFrame(spotGlideRaf);
    }

    function spotAdvance() {
      if (!spotSeen || document.hidden || Date.now() < spotHeld) return;
      var step = spotStepSize();
      /* rewind a whole set before the glide starts, never during it, so the
         seam is crossed while a card is resting rather than mid-move */
      if (spotPeriodSet && spotTrack.scrollLeft + step >= spotPeriod * 2) {
        spotTrack.scrollLeft = spotTrack.scrollLeft - spotPeriod;
      }
      spotGlide(step);
    }

    function spotLoop() {
      var slides = Array.prototype.slice.call(spotTrack.children);
      if (slides.length < 2) return;
      /* a lead copy and a trailing copy, so there is room to wrap in both
         directions; clones are decorative and hidden from assistive tech.
         The lead copy is inserted before the first real slide rather than at
         firstChild — inserting at the front in a forward loop would reverse
         it, the three copies would stop being identical, and the wrap would
         land on different cards instead of being invisible. */
      var anchor = slides[0];
      function copy(where) {
        slides.forEach(function (li) {
          var c = li.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.setAttribute('data-cc-spot-clone', '');
          if (where === 'lead') spotTrack.insertBefore(c, anchor);
          else spotTrack.appendChild(c);
        });
      }
      copy('tail');
      copy('lead');
      spotMeasure();
      spotTrack.scrollLeft = spotPeriod;
      if (spotControls) spotControls.hidden = false;
      spotSync();

      ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
        spotTrack.addEventListener(evt, spotHold, { passive: true });
      });

      /* Nothing moves until the rail is properly on screen, and the timer is
         thrown away when it leaves. A sliver appearing at the bottom edge is
         not "seen" — organic butter has to be sitting in front of the
         visitor before anything steps, or they arrive to find the rail
         already halfway through the set. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          spotSeen = entries[0].isIntersecting;
          if (spotSeen) spotPlay();
          else spotPause();
        }, { threshold: 0.6 }).observe(spotTrack);
      } else {
        spotSeen = true;
        spotPlay();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) spotPause();
        else if (spotSeen) spotPlay();
      });
    }

    if (!reduceMotion && spotTrack.scrollWidth > spotTrack.clientWidth + 1) {
      /* the period is measured off laid-out slides, so wait for the images
         that give them their height before cloning anything */
      if (document.readyState === 'complete') spotLoop();
      else window.addEventListener('load', spotLoop, { once: true });
    }
  }

  /* ---------- headline ingredient rotator ----------
     Swaps the serif word under the gallery: fade the current one up and
     out, drop the next one in from below. The list starts with whatever
     is in the Liquid, so the first paint is never blank. Pauses while the
     tab is hidden — no point animating to nobody — and while the visitor
     has asked for reduced motion, where the word simply rests on whichever
     ingredient it was showing. */
  var rotator = root.querySelector('[data-cc-rotator]');
  var rotatorFancy = rotator && rotator.querySelector('[data-cc-rotator-fancy]');
  var rotatorWord = rotator && rotator.querySelector('[data-cc-rotator-word]');
  if (rotatorWord && rotatorFancy) {
    /* The wave under the word is a background on the fancy, and the fancy
       is auto-width, so on a swap it would snap to the new word's length.
       Pinning an explicit px width lets CSS transition it instead. The
       measurement has to be redone whenever the type changes size — a
       resize (the h2 is fluid) or the serif finishing loading — or the
       wave is left at a stale length with the word poking out past it. */
    function fitWave() {
      rotatorFancy.style.width = rotatorWord.offsetWidth + 'px';
    }
    fitWave();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitWave);
    window.addEventListener('resize', fitWave);
    /* Each one finishes "We only use ___", so they're all positives (a
       negative reads as broken grammar there). The box is fixed to the
       longest phrase — "madagascar vanilla." at 7.67em, rounded up to 7.8em
       in .cc-headline2__rotator — so keep any new one under that or the
       sentence will re-wrap mid-swap. */
    var INGREDIENTS = [
      'organic butter.',
      'real matcha.',
      'fairtrade cocoa.',
      'fresh fruit.',
      'madagascar vanilla.',
      'free-range eggs.'
    ];
    var first = rotatorWord.textContent.trim();
    var startAt = INGREDIENTS.indexOf(first);
    if (startAt < 0) { INGREDIENTS.unshift(first); startAt = 0; }
    var ingredientIdx = startAt;
    var HOLD = 1300;
    var FADE = 220;
    /* Read .matches per tick rather than caching it: the query is live, so
       toggling the OS setting (or DevTools' emulation of it) takes hold on
       the next tick with no reload. Returning before the --out class goes on
       means a pause can never strand the word mid-fade. */
    var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    function nextIngredient() {
      if (document.hidden) return;
      if (frozen()) return;
      if (motionQuery && motionQuery.matches) return;
      rotator.classList.add('cc-headline2__rotator--out');
      window.setTimeout(function () {
        ingredientIdx = (ingredientIdx + 1) % INGREDIENTS.length;
        rotatorWord.textContent = INGREDIENTS[ingredientIdx];
        /* the word is invisible right now, so the wave glides to the new
           length on its own while the word fades back in behind it */
        fitWave();
        rotator.classList.remove('cc-headline2__rotator--out');
        rotator.classList.add('cc-headline2__rotator--in');
        /* next frame, drop the no-transition class so the word animates in */
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            rotator.classList.remove('cc-headline2__rotator--in');
          });
        });
      }, FADE);
    }
    window.setInterval(nextIngredient, HOLD + FADE);
  }

  /* ---------- sticky "Choose your cookies" ----------
     Visible while the flavour picker is outside the top 70% of the
     screen, in either direction (a sliver peeking in under the bar doesn't
     count); the tap scrolls the picker into view. */
  var stick = root.querySelector('[data-cc-stick]');
  var stickPicker = root.querySelector('.cc-picker');
  if (stick && stickPicker) {
    var stickBtn = stick.querySelector('[data-cc-stick-btn]');
    var stickShown = null;
    var stickQueued = false;
    /* Measured on every scroll rather than with an IntersectionObserver: a fast
       fling can jump the picker from below the fold to above it in one frame,
       and the observer never fires for a jump that skips the intersecting state. */
    var stickUpdate = function () {
      stickQueued = false;
      var r = stickPicker.getBoundingClientRect();
      var inView = r.top < window.innerHeight * 0.7 && r.bottom > 0;
      /* first screens with their own button (html.mk-on) only want the bar once the picker is scrolled past */
      var pastOnly = !!document.querySelector('[data-mk]');
      var show = !inView && (!pastOnly || r.top < 0);
      if (show === stickShown) return;
      stickShown = show;
      stick.classList.toggle('cc-stick--visible', show);
      if (stickBtn) stickBtn.tabIndex = show ? 0 : -1;
      if (show) journey.step('sticky_shown');
    };
    var stickSchedule = function () {
      if (stickQueued) return;
      stickQueued = true;
      requestAnimationFrame(stickUpdate);
    };
    window.addEventListener('scroll', stickSchedule, { passive: true });
    window.addEventListener('resize', stickSchedule, { passive: true });
    stickSchedule();
    setTimeout(stickUpdate, 600);
    if (stickBtn) stickBtn.addEventListener('click', function () {
      journey.step('sticky_tap');
      var y = stickPicker.getBoundingClientRect().top + window.scrollY - 160;
      window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* ---------- first bite reactions ----------
     Clips load only when tapped, into one shared lightbox video. */
  var bitesModal = document.querySelector('[data-cc-bites-modal]');
  var bitesVideo = bitesModal && bitesModal.querySelector('[data-cc-bites-video]');
  if (bitesModal && bitesVideo) {
    /* .cc-pdp__below is its own stacking context (z-index 1), which would
       trap the lightbox under the sticky header */
    document.body.appendChild(bitesModal);
    var closeBite = function () {
      bitesVideo.pause();
      bitesVideo.removeAttribute('src');
      bitesVideo.load();
      bitesModal.hidden = true;
      document.documentElement.style.overflow = '';
    };
    root.querySelectorAll('[data-cc-bite]').forEach(function (card) {
      card.addEventListener('click', function () {
        journey.step('bite_video_' + card.getAttribute('data-cc-bite-id'));
        bitesVideo.src = card.getAttribute('data-cc-bite');
        bitesModal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var p = bitesVideo.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
    bitesModal.querySelector('[data-cc-bites-close]').addEventListener('click', closeBite);
    bitesModal.addEventListener('click', function (e) { if (e.target === bitesModal) closeBite(); });
    bitesVideo.addEventListener('ended', closeBite);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !bitesModal.hidden) closeBite();
    });
  }

  /* ---------- init ---------- */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.source === 'cc-pdp') return;
    fetchCart();
  });
  renderTiles();
  renderAddBar();
  onScroll();
  goSlide(0);
  fetchCart();
})();
